import React, {useReducer} from 'react'
import {TourContext} from './TourContext'
import {TOUR_ACTION} from "../../constant"

const initialModal = {
	open: false,
	tour: false,
	stepIndex: 0,
	openDropdown: false,
}

const tourReducer = (state, action) => {
	switch (action.type){
		case TOUR_ACTION.OPEN: {
			return {...state, ...{open: true}, ...action.payload}
		}
		case TOUR_ACTION.SET_INDEX: {
			return {...state, ...{stepIndex: action.payload || 0}}
		}
		case TOUR_ACTION.CLOSE: {
			return {...state, ...{open: false}, ...action.payload}
		}
		case TOUR_ACTION.OPEN_DROPDOWN: {
			return {...state, ...{openDropdown: action.payload}}
		}
		default: {
			return state
		}
	}
}


export function TourProvider({children}){
	const [tour, dispatch] = useReducer(tourReducer, initialModal)

	return <TourContext.Provider value={{
		tour,
		openTour: (params) => dispatch({type: TOUR_ACTION.OPEN, payload: params}),
		onStepIndex: (stepIndex) => dispatch({type: TOUR_ACTION.SET_INDEX, payload: stepIndex}),
		dropdownTour: (open) => dispatch({type: TOUR_ACTION.OPEN_DROPDOWN, payload: open}),
		closeTour: (params) => dispatch({type: TOUR_ACTION.CLOSE, payload: params}),
	}}>
		{children}
	</TourContext.Provider>
}